import { useCurrentUser } from './useCurrentUser';

export function useSubscriptionSeats(comparator: (seats: number) => boolean): boolean {
  const user = useCurrentUser();

  if (!user?.company?.subscriptionSeats) return false;

  return comparator(user.company.subscriptionSeats);
}
